import { Injectable } from "@angular/core";
import { GeoLocationModel } from "src/domain/client";
import { StockholmCenterCoordinates } from "src/domain/constants";
import { NonUserError } from "src/errors";

@Injectable({
  providedIn: "root",
})
export class MapService {
  geoLocationModel?: GeoLocationModel;
  constructor() {}
  stockholmCenterCoordinates = StockholmCenterCoordinates;

  getCurrentPosition(): Promise<GeoLocationModel> {
    return new Promise<GeoLocationModel>((resolve, reject) => {
      if (!navigator.geolocation) {
        return reject(new NonUserError("Geolocation not supported"));
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.geoLocationModel = new GeoLocationModel({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });

          resolve(this.geoLocationModel);
        },
        () => {
          this.geoLocationModel = new GeoLocationModel({
            latitude: this.stockholmCenterCoordinates.lat,
            longitude: this.stockholmCenterCoordinates.lng,
          });
          resolve(this.geoLocationModel);
        },
      );
    });
  }
}
